import {
	Card,
	CardActionArea,
	CardContent,
	CardHeader,
	Grid,
	Typography
} from '@mui/material';
import { SSOTypes } from 'types/settings';
import React, { useCallback } from 'react';

interface ISSOCardProps {
	title: SSOTypes;
	onClick: (title: SSOTypes) => void;
}

const SSOCard: React.FC<ISSOCardProps> = ({ title, onClick }) => {
	const onClickCallback = useCallback(() => {
		onClick(title);
	}, [onClick, title]);

	return (
		<Grid item xs={6} pr={2}>
			<CardActionArea
				onClick={onClickCallback}
				data-testid={`sso-card-${title}`}
				sx={{ display: 'flex' }}
			>
				<Card sx={{ height: 135, boxShadow: 4, flex: 1 }}>
					<CardHeader
						title={intl.tr(
							`pages.authMethods.sso.card.title.${title.toLowerCase()}`
						)}
					/>
					<CardContent sx={{ pt: 0 }}>
						<Typography variant="body2" color="textSecondary">
							{intl.tr(
								`pages.authMethods.sso.card.description.${title.toLowerCase()}`
							)}
						</Typography>
					</CardContent>
				</Card>
			</CardActionArea>
		</Grid>
	);
};

export default SSOCard;
